/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="center"
      px="30px"
      py="40px"
      bg={'#0C1C2C'}
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
      >
        Poolme 
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as="span">
          All Rights Reserved
        </Text>
     
      </Text>
      {/* <List display="flex">
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link color="gray.400" href="#contact">
            Contact Us
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link color="gray.400" href="#about">
            About Us
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link
            color="gray.400"
            href="#blog"
          >
            Privacy Policy
          </Link>
        </ListItem>
        <ListItem>
          <Link
            color="gray.400"
            href="#license"
          >
            Terms & Conditions
          </Link>
        </ListItem>
      </List> */}
    </Flex>
  );
}
